<section id="about" class="box-white">
    <div class="wrapper padding-all">
        <!-- Section Content -->
        <div class="row margin-none">
            <div class="col-md-12 col-sm-12 padding-none padding-right-40">
                <!-- About Header -->
                <div class="section-header">
                    <h1 class="title-big letter-spacing line-bottom left">कर्जसंबधी सविस्तर माहिती.</h1>
                    <h3>
                        नागपूर महानगरपालिका कर्मचारी सहकारी बँक ली. आपल्या सभासदांना विविध प्रकाचे कर्ज पुरवठा माफक व्यजदरात करते.
                    </h3>
                </div>
                <!-- About Header End -->
                <table class="table table-striped responsive">
                    <thead>
                        <tr>
                            <th scope="col">क्र.</th>
                            <th scope="col">कर्ज प्रकार</th>
                            <th scope="col">व्याज दर</th>
                            <th scope="col">कर्ज मर्यादा</th>
                            <th scope="col">कालावधी</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1</th>
                            <td>तातडीचे कर्ज (सभासद) </td>
                            <td>१३%</td>
                            <td>२,००,०००/- </td>
                            <td>७२ महिने </td>
                        </tr>
                        <tr>
                            <th scope="row">2</th>
                            <td>साधे कर्ज (सभासद) </td>
                            <td>१३%</td>
                            <td>२.००,०००/- </td>
                            <td>१०० महिने </td>
                        </tr>
                        <tr>
                            <th scope="row">3</th>
                            <td>अतिरिक्त कर्ज (सभासद) </td>
                            <td>१३%</td>
                            <td>२,५०,०००/- </td>
                            <td>१०० महिने </td>
                        </tr>
                        <tr>
                            <th scope="row">4</th>
                            <td>नैमित्तिक कर्ज (सभासद)</td>
                            <td>१३%</td>
                            <td>२,५०,०००/- </td>
                            <td>१०० महिने </td>
                        </tr>
                        <tr>
                            <th scope="row">5</th>
                            <td>वैयक्तिक कर्ज (सभासद/नाममात्र सभासद) </td>
                            <td>१६%</td>
                            <td>१,००,०००/-  </td>
                            <td>४८ महिने </td>
                        </tr>
                        <!-- <tr>
                            <th scope="row">6</th>
                            <td>घर दुरुस्ती कर्ज (फेरफार/सुधार)</td>
                            <td>१४%</td>
                            <td>५,००,०००/- </td>
                            <td>१८० महिने </td>
                        </tr> -->
                        <tr>
                            <th scope="row">6</th>
                            <td>घरगहाणी कर्ज (घरखरेदी/बांधणी/परतावा) (सभासद)</td>
                            <td>९%</td>
                            <td>५०,००,०००/- </td>
                            <td>२४० महिने </td>
                        </tr>
                        <tr>
                            <th scope="row">7</th>
                            <td>घर दुरुस्ती कर्ज (सभासद)</td>
                            <td>१४%</td>
                            <td>५,००,०००/- </td>
                            <td>१२० महिने </td>
                        </tr>
                        <tr>
                            <th scope="row">8</th>
                            <td>वैद्यकीय कर्ज (सभासद)</td>
                            <td>९%</td>
                            <td>१,००,०००/- </td>
                            <td>६० महिने </td>
                        </tr>
                        <tr>
                            <th scope="row">9</th>
                            <td>वाहन कर्ज (सभासद) चारचाकी/दुचाकी <br/>वाहन कर्ज इलेक्ट्रिक चारचाकी/दुचाकी </td>
                            <td>९% / ९.१५%
                                <br>८.५% / ८.२५% </td>
                            <td>मूळ किमतीच्या १००%  <br> मूळ किमतीच्या १००%  </td>
                            <td>८४/६० महिने 
                                <br>८४/६० महिने   </td>
                        </tr>
                        <!-- <tr>
                            <th scope="row">10</th>
                            <td>संगणक कर्ज (सभासद)</td>
                            <td>१६%</td>
                            <td>५०,०००/- </td>
                            <td>६० महिने </td>
                        </tr> -->
                        <tr>
                            <th scope="row">10</th>
                            <td>शैक्षणिक कर्ज पाल्याच्या शिक्षणाकरिता (सभासद) </td>
                            <td>१०%</td>
                            <td>५,००,०००/- </td>
                            <td>६० महिने </td>
                        </tr>
                        <tr>
                            <th scope="row">11</th>
                            <td>मालमत्ता तारण कर्ज (सभासद)</td>
                            <td>१३%</td>
                            <td>२५,००,०००</td>
                            <td>१२० महिने</td>
                        </tr>
                        <!-- <tr>
                            <th scope="row">14</th>
                            <td>संगणक कर्ज (नाममात्र सभासद)</td>
                            <td>१८%</td>
                            <td>१,००,०००/- </td>
                            <td>३६ महिने</td>
                        </tr> -->
                        <tr>
                            <th scope="row">12</th>
                            <td>पेन्शन कर्ज (नाममात्र सभासद स्वतःची / कौटुंबिक )</td>
                            <td>१३.५०%</td>
                            <td>पेन्शनची ८ पट किंवा १,००,०००/- जास्तीत जास्त <br/>पेन्शनची ८ पट किंवा ६०,०००/- जास्तीत जास्त </td>
                            <td>३६ महिने</td>
                        </tr>
                        <!-- <tr>
                            <th scope="row">16</th>
                            <td>एमिनिटी कर्ज (नाममात्र सभासद) <br> एमिनिटी कर्ज (नाममात्र सभासद)ना. म. न. पा. तील स्थाई <br>कर्मचारी जे बँकेचे सभासद नाही त्यांच्या करीता </td>
                            <td>१८%<br>१८%</td>
                            <td>५०,०००/-
                                <br>१,००,०००/- </td>
                            <td>३६ महिने<br>३६ महिने</td>
                        </tr> -->
                        <tr>
                            <th scope="row">13</th>
                            <td>सोने तारण कर्ज </td>
                            <td>९.००%</td>
                            <td>२,००,०००/- </td>
                            <td>१२ महिने</td>
                        </tr>
                        <tr>
                            <th scope="row">14</th>
                            <td>सोलर कर्ज</td>
                            <td>१०% </td>
                            <td>५,००,०००/-</td>
                            <td>३६/६० महिने</td>
                        </tr>
                        <tr>
                            <th scope="row">15</th>
                            <td>वाहन कर्ज (नाममात्र सभासद) दुचाकी</td>
                            <td>९.१५%</td>
                            <td>किमतीचे १००%</td>
                            <td>३६महिने</td>
                        </tr>
                    </tbody>
                </table>
                <div class="space"></div>
                <div class="button-group clearfix ">
                    <a routerLink="/about" class="btn btn-default letter-spacing">अधिक माहिती </a>
                    <a routerLink="/contact" class="btn btn-dark letter-spacing">संपर्क</a>
                </div>
                <!-- About Content End -->
            </div>
        </div>
        <!-- Section Content End -->
    </div>

</section>